// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

@keyframes SMBGRangeAnimated--fadein--tUMqx {
  from {
    fill-opacity: 0.3;
  }
  to {
    fill-opacity: 0.4;
  }
}

@keyframes SMBGRangeAnimated--fadeout--MKPc1 {
  from {
    fill-opacity: 0.4;
  }
  to {
    fill-opacity: 0.3;
  }
}

.SMBGRangeAnimated--smbgRange--dnxhO {
  fill: var(--trends--light);
  stroke: none;
}

.SMBGRangeAnimated--fadeIn--KuU3N {
  animation: SMBGRangeAnimated--fadein--tUMqx 0.25s forwards ease-in-out;
}

.SMBGRangeAnimated--fadeOut--TweZh {
  animation: SMBGRangeAnimated--fadeout--MKPc1 0.25s forwards ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/components/trends/smbg/SMBGRangeAnimated.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,sEAA4C;AAC9C;;AAEA;EACE,uEAA6C;AAC/C","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n@keyframes fadein {\n  from {\n    fill-opacity: 0.3;\n  }\n  to {\n    fill-opacity: 0.4;\n  }\n}\n\n@keyframes fadeout {\n  from {\n    fill-opacity: 0.4;\n  }\n  to {\n    fill-opacity: 0.3;\n  }\n}\n\n.smbgRange {\n  fill: var(--trends--light);\n  stroke: none;\n}\n\n.fadeIn {\n  animation: fadein 0.25s forwards ease-in-out;\n}\n\n.fadeOut {\n  animation: fadeout 0.25s forwards ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"smbgRange": `SMBGRangeAnimated--smbgRange--dnxhO`,
	"fadeIn": `SMBGRangeAnimated--fadeIn--KuU3N`,
	"fadein": `SMBGRangeAnimated--fadein--tUMqx`,
	"fadeOut": `SMBGRangeAnimated--fadeOut--TweZh`,
	"fadeout": `SMBGRangeAnimated--fadeout--MKPc1`
};
export default ___CSS_LOADER_EXPORT___;
